import React, { useState, useEffect } from 'react';

import { useLocation, useHistory, Link } from 'react-router-dom'
import axios from 'axios'

import { LinkHelper, ShareHelper } from "../helpers"
import { LatestListingList, Loading, PageList, Separator } from "../components"
import { getApiUrl } from '../../src/core/config/api';

const parseLocation = (location) => {
    const arr = (location.pathname + location.search).substr(1).split('/')

    if (['master-library', 'events', 'news'].includes(arr[0])) {
        return {
            type: {
                'master-library': 'library',
                'events': 'event',
                'news': 'news'
            }[arr[0]],
            slug: arr.slice(1).join('/')
        }
    }

    return {
        type: 'page',
        slug: arr.join('/')
    }
}

const Page = () => {
    const location = useLocation()
    const history  = useHistory()

    const [ page, setPage ] = useState()
    const { type, slug } = parseLocation(location)

    const onShareClick = () => {
        const link = LinkHelper.link(getApiUrl(`/media/${page.datasheet}`));
        ShareHelper.share(link)
    }

    useEffect( () => {
        const loadPage = async () => {
            setPage(null)

            try {
                const { data } = await axios.get(getApiUrl('/api/pages'), {
                    params: { type, slug }
                });

                setPage(data)
            } catch (error) {
                if (error?.response?.status === 404) {
                    return history.push('/error/404')
                }

                throw error
            }
        }

        loadPage()
    }, [type, slug]);

    const categoryTitle = {
        //'event': 'Events',
        'news': 'News',
        'library': 'Master Library'
    }[type]

    const categoryLink = {
        //'event': '/events',
        'news': '/news'
    }[type]

    const otherTitle = {
        //'event': 'Other Events',
        'news': 'Other News',
        'library': 'Other articles'
    }[type]

    return (
        <main id='page' className={`flex-grow-1 ${page?.type}`}>
            { !page && (
                <Loading type="Loading..." text="Loading page..." />
            )}

            { page && (
                <>
                    <div className="container">
                        <div className="breadcrumbs">
                            <Link to={categoryLink}>{categoryTitle}</Link> {"<"} { page.title }
                        </div>

                        { page.image && <img className="" src={getApiUrl(`/media/${page.image}`)} style={{
                            width: '100%',
                            aspectRatio: '19/5',
                        }} /> }

                        <h1 className="mx-3 mx-md-0 mt-3 mb-2">{page.title}</h1>

                        { page.header_text && <p className="header-text mt-2 mx-3 mx-md-0">{page.header_text}</p>}

                        { type === 'event' && (
                            <div className="d-lg-none">
                                <h2>What you'll do</h2>
                                <Separator noMargin className="mt-2 mx-3 mb-2" />
                            </div>
                        )}
                    </div>

                    { type === 'event' && (
                        <div className="d-none d-lg-block">
                            <Separator noMargin className="mt-2 mb-2" />
                        </div>
                    )}

                    <div className="container">
                        { type === 'event' && (
                            <h2 style={{ fontSize: '26px', letterSpacing: '1.04px', textTransform: 'none'}} className="my-4 d-none d-lg-block">What you'll do</h2>
                        )}

                        <div className="content pt-0 p-3 p-md-0" dangerouslySetInnerHTML={{ __html: page.content}} />

                        { page.datasheet && (
                            <>
                                <a className="attachment mb-5 mx-3 mx-md-0" href={getApiUrl(`/media/${page.datasheet}/download`)}>Download Document</a>
                                <button className="next mb-4 mx-3 mx-md-1" onClick={onShareClick}>Share Now</button>
                            </>
                        )}
                    </div>

                    { page.type !== 'page' && (
                        <>
                            <Separator noMargin className="mt-3 mb-0" />

                            <div className="container subsection">
                                <h2 className="mb-2 mb-lg-4">{otherTitle}</h2>
                                <PageList type={page.type} exclude={page.id} itemComponent={2} />
                            </div>

                            <Separator noMargin className="mb-0 d-none d-lg-block" />

                            <div className="container subsection">
                                <h2 className="mb-2 mb-lg-4">Latest Products</h2>
                                <LatestListingList />
                            </div>
                        </>
                    )}
                </>
            )}
        </main>
    )
}

export default Page
